export const defaultCommonState = {
	filterTaxPaper: {},
	filterDisplayTaxPaper: {},
	optionsFilterTaxPaper: {}
};

export default {
	...defaultCommonState
};
